import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);
const KEY = "wiggles_pets";

const DEFAULTS = [
  { id: "king", name: "King", breed: "Blue-nose Pit", size: "L", city: "vegas" },
  { id: "beats", name: "Beats", breed: "Pit Mastiff", size: "L", city: "nyc" },
  { id: "smiley", name: "Smiley", breed: "American Pit", size: "M", city: "miami" },
];

export function PetProfileProvider({ children }) {
  const [pets, setPets] = useState(() => {
    try { const s = JSON.parse(localStorage.getItem(KEY)); return s && s.length ? s : DEFAULTS; } catch { return DEFAULTS; }
  });
  const [activeId, setActiveId] = useState(() => (pets[0]?.id || null));

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(pets)); }, [pets]);

  const addPet = (p) => {
    const np = { ...p, id: "pet_" + Date.now() };
    setPets((x) => [...x, np]);
    setActiveId(np.id);
  };

  const activePet = pets.find((p) => p.id === activeId) || null;

  return (
    <Ctx.Provider value={{ pets, activePet, activeId, setActiveId, addPet }}>
      {children}
    </Ctx.Provider>
  );
}

export const usePets = () => useContext(Ctx);
